import Box from '@mui/material/Box';
import { useCallback } from 'react';

import RateCardIndicator from '~components/RateCard/RateCardIndicator';
import { Project } from '~hooks/useProjects/models';
import { useSiteRateSchedule } from '~hooks/useSiteRateSchedule/useSiteRateSchedule';

/**
 * The rate-card affordance for a project row.
 *
 * A project's list payload carries no rate-card data at all, so the cards are fetched on
 * first hover. Unlike an order, a project has no "applied" card — every card it owns is a
 * candidate that orders match against — so no card is starred here.
 */

interface ProjectRateCardIndicatorProps {
  project: Project;
}

export default function ProjectRateCardIndicator({
  project,
}: ProjectRateCardIndicatorProps) {
  // The throwing variant, so a failed fetch renders the indicator's failure state
  // instead of reading as "no rate cards".
  const { fetchAllProjectSiteRateSchedules } = useSiteRateSchedule();

  const loadRateCards = useCallback(
    () => fetchAllProjectSiteRateSchedules(project.id),
    [fetchAllProjectSiteRateSchedules, project.id],
  );

  // 12px matches the project card's subtitle line, which this sits directly beneath.
  return (
    <Box sx={{ fontSize: '12px' }}>
      <RateCardIndicator loadRateCards={loadRateCards} />
    </Box>
  );
}
